import React from 'react';
import Grid from '@/components/molecules/Grid';
import styled from 'styled-components';
import { device, radius } from '@/styles/template';

interface Props {
	children: React.ReactNode;
}

const Wrap = styled.div`
  background-color: ${props => props.theme.color.Background};
  padding: 4rem 2rem;
  width: 100%;
  border-radius: ${radius.large};

  @media screen and  ${device.tablet} {
    padding: 0;
    background-color: transparent;
  }
`;

const SocialNetworks: React.FC<Props> = ({children}) => {
	return (
		<>
			{children && <Wrap>
                <Grid col='1' gap='2' centeredContent>
					{children}
                </Grid>
            </Wrap>}
		</>
	)
}

export default SocialNetworks